//import "bootstrap/dist/css/bootstrap.css";
import "vue-multiselect/dist/vue-multiselect.css";
//import 'v-tooltip/dist/v-tooltip.css'
import "core-js/stable";
import "regenerator-runtime/runtime";

import { createApp, h } from "vue";
import App from './App.vue'
import router from "./router";
//import 'sweetalert2/dist/sweetalert2.min.css';
//import VueSweetalert2 from 'vue-sweetalert2';
import { store } from './store';
//import VTooltipPlugin from 'v-tooltip'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
import 'v-calendar/dist/style.css';
import { vMaska } from "maska"

// de themes
import 'src/assets/css/fonts.css';
import 'src/assets/css/bootstrap.min.css';
import 'src/assets/css/icons.css';
import 'src/assets/css/magnific-popup.css';
import 'src/assets/css/slidebars.min.css';
import 'src/assets/css/menu.css';
import 'src/assets/css/styles.css';

const app  = createApp({
    render: ()=>h(App)
});
// para mascaras
app.directive("maska", vMaska);
app.use(store);
app.use(router);
//app.use(VueSweetalert2);
//app.use(VTooltipPlugin);
app.config.productionTip = false;
app.mount("#app");
